import React, { useState, useEffect, useMemo } from 'react';
import { Breadcrumb, Col, Form, Row } from "react-bootstrap";
import Loader from '../../UI/loader/loader';
import Graybg from '../../UI/Graybg';
import Card from '../../UI/Card/Card';
import DatePicker from "react-datepicker";
import { Search } from 'lucide-react';
import Toast from '../../UI/Toast/Toast';
import userService from '../../app/services/user.service';
import { toast } from 'react-toastify';
import { isEmpty } from '../../utils/custom_funtions';
import SecBTN from '../../UI/SecBTN';
import classes from './CopyRequest.module.css';
import { useNavigate } from 'react-router-dom';
const CopyRequest = () => {
  const [searchInput, setSearchInput] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [loading, setLoading] = useState(false);
  const [copyRequestData, setCopyRequestData] = useState([]);
  const [pageNo, setPageNo] = useState(0);
  const listCount = 50;
  const navigate=useNavigate();

  // Remove initial API call - only call API when search or apply filter is clicked
  // useEffect(() => {
  //   fetchCopyRequestData();
  // }, []);

  // Fetch copy request data function
  const fetchCopyRequestData = (searchQuery = searchInput, start = startDate, end = endDate) => {
    setLoading(true);
    const payload = {
      start_date: start ? formatDate(start) : "",
      end_date: end ? formatDate(end) : "",
      search_paper: searchQuery || "",
    };
    
    console.log("API Payload:", payload);
    
    userService
      .getCopyPaperList(payload)
      .then((data) => {
        setLoading(false);
        let datas = data.data.data;
        
        setCopyRequestData(datas);
        console.log("Copy Request Data:",datas);
      })
      .catch((error) => {
        setLoading(false);
        console.log("error", error);
        toast.error(error.message);
      });
  };

  // Handle search input change
  const handleSearchInputChange = (e) => {
    setSearchInput(e.target.value);
  };

  // Handle Enter key press on search input
  const handleSearchKeyPress = (e) => {
    if (e.key === 'Enter') {
      if (!startDate || !endDate) {
        toast.error('Please select a date range');
        return;
      }
      handleSearchClick();
    }
  };

  // Handle date range changes
  const handleDateChange = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);          
  };

  // Format date to YYYY-MM-DD
  const formatDate = (date) => {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('-');
  };

  // Handle search button click
  const handleSearchClick = () => {
    if (!startDate || !endDate) {
      toast.error('Please select a date range');
      return;
    }
    // Reset pagination when searching
    setPageNo(0);
    
    // Call API with current search input and date range
    fetchCopyRequestData(searchInput, startDate, endDate);
  };

  // Handle apply filter button click (works with date range or search input)
  const handleApplyFilter = () => {
    if (!startDate || !endDate) {
      toast.error('Please select a date range');
      return;
    }
    // Reset pagination when filtering
    setPageNo(0);
    
    // Call API with current search input and date range
    fetchCopyRequestData(searchInput, startDate, endDate);
  };

  // Handle copy request button click
  const handleCopyRequest = (paperId) => {
    console.log("Copy Request for:", paperId);
    // TODO: Implement copy request functionality
    // toast.success(`Copy request submitted for: ${paperData.paper_name}`);
    userService
      .getDuplicatePaper(paperId)
      .then((data) => {
        setLoading(false);
        let datas = data.data.data;
        
        
        console.log("Copy Request Data:",datas);
         navigate(`/editPaper/${datas.new_paper_id}`)
      })
      .catch((error) => {
        setLoading(false);
        console.log("error", error);
        toast.error(error.message);
      });
   
    
  };

  // Use the data directly from API (no client-side filtering since we're using server-side search)
  const searchedData = useMemo(() => {
    return copyRequestData;
  }, [copyRequestData]);

  return (
    <>
      <Toast />
      {loading && <Loader />}
      <div className="section">
        <div className="d-flex flex-column flex-md-row justify-content-start justify-content-md-between align-items-start align-items-md-center">
          <div>
            <h4>Copy Request</h4>
            <Breadcrumb>
              <Breadcrumb.Item active>Copy Request</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <div className='d-flex gap-3 align-items-center mb-3'>
            {/* <div className="d-flex">
              <input
                type="text"
                className="form-control me-2"
                placeholder="Search papers..."
                value={searchInput}
                onChange={handleSearchInputChange}
                onKeyPress={handleSearchKeyPress}
              />
              <button 
                className="btn sec-btn1 d-flex align-items-center" 
                onClick={handleSearchClick}
              >
                <Search size={16} className="me-2" />
                Search
              </button>
            </div> */}
            <div className={`d-flex justify-content-center align-items-center gap-3 ${classes.btnsec}`}>
              <SecBTN className='sec-btn me-0' disabled={pageNo == 0} onClick={() => setPageNo(pageNo - 1)}>
                <i className="fa-solid fa-arrow-left"></i>
              </SecBTN>
              <p style={{ width: "60px" }} className='text-center'>
                {`${Math.ceil(searchedData.length / 50) == 0 ? 0 : pageNo + 1} / ${Math.ceil(searchedData.length / 50)}`}
              </p>
              <SecBTN className='sec-btn' disabled={pageNo + 1 == Math.ceil(searchedData.length / 50) || Math.ceil(searchedData.length / 50) == 0} onClick={() => setPageNo(pageNo + 1)}>
                <i className="fa-solid fa-arrow-right"></i>
              </SecBTN>
            </div>
          </div>
        </div>
      </div>

      <Graybg>
        <Card className="mb-4">
          <Row>
            <Col md={5}>
              <Form.Label>Search :</Form.Label>
              <div className="d-flex">
                <input
                  type="text"
                  className="form-control mb-2 me-2"
                  placeholder="Enter search query..."
                  value={searchInput}
                  onChange={handleSearchInputChange}
                  onKeyPress={handleSearchKeyPress}
                />
                <button 
                  className="btn sec-btn1 d-flex align-items-center mb-2" 
                  onClick={handleSearchClick}
                  disabled={!startDate || !endDate}
                >
                  <Search size={16} className="me-2" />
                  Search
                </button>
              </div>
            </Col>
            <Col md={5}>
              <Form.Label>Date Range :</Form.Label>
              <div>
              <DatePicker
                selected={startDate}
                onChange={handleDateChange}
                startDate={startDate}
                endDate={endDate}
                selectsRange
                className="form-control mb-2"
                placeholderText="Select date range"
                dateFormat="dd/MM/yyyy"
              />
              </div>
            </Col>
            <Col md={2} className="d-flex align-items-end mb-2">
              <button 
                className="btn sec-btn1 w-100" 
                onClick={handleApplyFilter}
                disabled={!startDate || !endDate}
              >
                Apply Filter
              </button>
            </Col>
          </Row>
        </Card>
        
        {/* Display cards with copy request data */}
        {
          isEmpty(searchedData) ? (
            !loading &&
            <p className="text-center">No search results. Use the search or filter options above to find papers.</p>
          ) : (
            searchedData?.slice(listCount * pageNo, (pageNo + 1) * listCount)?.map((data, i) => (
              <Card key={i}>
                <Row>
                  <Col lg={10} md={8} sm={12}>
                    <h5>
                      {data.paper_name}
                    </h5>
                    <Row>
                      <Col lg={8} md={6} sm={12}>
                        <p><strong>Class : </strong> {data.class}</p>
                        <p><strong>Target :</strong> {data.target}</p>
                        <p><strong>Format : </strong>{data.format}</p>
                        <p><strong>Questions Assigned by :</strong> {data.creator}</p>
                      </Col>
                      <Col lg={4} md={6} sm={12}>
                        <p><strong>Assigned on :</strong> {new Date(data.created_on).toLocaleDateString("sv-SE")}</p>
                        <p><strong>Exam Date : </strong>{data.to_be_held_on}</p>
                        <p><strong>Date Of Submission : </strong> {data.to_be_completed_by}</p>
                      </Col>
                    </Row>
                  </Col>
                  <Col lg={2} md={4} sm={12} className="text-end">
                    <SecBTN 
                      className={classes["copy-request-btn"]}
                      onClick={() => handleCopyRequest(data.pid)}
                    >
                      Copy Request
                    </SecBTN>
                  </Col>
                </Row>
              </Card>
            ))
          )
        }
      </Graybg>
    </>
  );
};

export default CopyRequest;